import { render, staticRenderFns } from "./ProcedureComponent.vue?vue&type=template&id=67857a21&"
import script from "./ProcedureComponent.vue?vue&type=script&lang=js&"
export * from "./ProcedureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports